import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '../../static/locales/en-US/strings.json'
import traverse from './traverse'
import store from '../store/index'
import {translationLanguages} from '../enums/supported-languages'
import q from 'q'
import superagent from 'superagent'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    'en': en
  }
})

function resolveSupportedLocales() {
  let supportedLocales = []
  let browserLocales = []
  if (navigator.languages) {
    browserLocales = navigator.languages
  } else {
    browserLocales.push(navigator.language)
  }
  browserLocales = norwegianPruning(browserLocales)
  for (let locale of browserLocales) {
    if (translationLanguages.find(o => o === locale)) {
      supportedLocales.push(locale)
    } else {
      if (locale.includes('-')) {
        locale = locale.substring(0, locale.indexOf('-'))
        if (translationLanguages.find(o => o === locale)) {
          supportedLocales.push(locale)
        }
      } else {
        for (let language of translationLanguages) {
          if (language.includes('-')) {
            if (locale === language.substring(0, language.indexOf('-'))) {
              supportedLocales.push(language)
            }
          } else {
            if (locale === language) {
              supportedLocales.push(locale)
            }
          }
        }
      }
    }
  }
  return [...new Set(supportedLocales)]
}

function norwegianPruning(browserLocales) {
  const norwegianLocales = ['no', 'nn']
  const requiredNorwegianLocale = 'nb'
  const prunedLocales = browserLocales.map(el => {
    if (norwegianLocales.includes(el)) {
      return requiredNorwegianLocale
    } else {
      return el
    }
  })
  return [...new Set(prunedLocales)]
}

function getLocalStringPath(locale) {
  const LOCALE_FOLDER = '/static/locales'
  return `${LOCALE_FOLDER}/${locale}/strings.json`
}

function setLocale(locale) {
  if (!locale) {
    if (resolveSupportedLocales()[0]) {
      locale = resolveSupportedLocales()[0]
    } else {
      locale = 'en'
    }
  }
  if (locale === 'FF') {
    return loadPseudoLanguage()
  } else {
    const stringsPath = getLocalStringPath(locale)
    return resolveStrings(stringsPath)
      .then((strings) => {
        console.log(`Setting localization to ${locale}.`)
        Vue.config.lang = locale

        i18n.setLocaleMessage(locale, strings.body)
        i18n.locale = locale
      }).catch((e) => {
        if (locale.indexOf('-') !== -1) {
          const language = locale.substr(0, locale.indexOf('-'))
          console.warn(`Failed to fetch strings for ${locale}. Trying ${language}.`)
          return setLocale(language)
        }
        console.warn(`Failed to fetch strings for ${locale}. Falling back to ${'en'}.`)
        console.warn(e)
        Vue.config.lang = 'en'

        store.commit('fallbackLocale', true)
        i18n.locale = 'en'
      })
  }
}

function loadPseudoLanguage() {
  const stringsPath = getLocalStringPath('en-US')
  let pseudoLanguage = {}
  return resolveStrings(stringsPath)
    .then((stringsJson) => {
      traverse.recurse(stringsJson.body, pseudoLanguage, function (value, outputNode, key) {
        if (key !== 'id' && key !== 'selected') {
          // string length excluding any text between links
          let str = value.match(/(?=(((?!>).)*<)|[^<>]*$)/g)
          const padLength = parseInt(Math.ceil(str.length / 3)) - 1
          let paddedStr = padString(value, padLength)
          outputNode[key] = makePseudoString(paddedStr)
        } else {
          outputNode[key] = value
        }
      })
      try {
        Vue.config.lang = 'FF'
        i18n.setLocaleMessage('FF', pseudoLanguage)
        i18n.locale = 'FF'
        console.log('Setting localization to pseudo language')
      } catch (err) {
        console.log(err)
      }
    })
}

function padString(str, padding) {
  let starFill = ''
  if (padding > 0) {
    starFill = Array(parseInt(padding)).join('*')
  }
  return '[' + starFill + str + starFill + ']'
}

function makePseudoString(str) {
  return str
  /*
   * the regex used below selects the particular letter at the beginning
   * of the expression outside of any<> tags so as to preserve any link config's such as hrefs, targets etc
   */
    .replace(/A(?=(((?!>).)*<)|[^<>]*$)/g, 'ÅÅ')
    .replace(/E(?=(((?!>).)*<)|[^<>]*$)/g, 'ÊÊ')
    .replace(/I(?=(((?!>).)*<)|[^<>]*$)/g, 'ÍÍ')
    .replace(/O(?=(((?!>).)*<)|[^<>]*$)/g, 'ÒÒ')
    .replace(/U(?=(((?!>).)*<)|[^<>]*$)/g, 'ÚÚ')
    .replace(/C(?=(((?!>).)*<)|[^<>]*$)/g, 'Ç')
    .replace(/N(?=(((?!>).)*<)|[^<>]*$)/g, 'Ñ')
    .replace(/a(?=(((?!>).)*<)|[^<>]*$)/g, 'åå')
    .replace(/e(?=(((?!>).)*<)|[^<>]*$)/g, 'éé')
    .replace(/i(?=(((?!>).)*<)|[^<>]*$)/g, 'íí')
    .replace(/o(?=(((?!>).)*<)|[^<>]*$)/g, 'óó')
    .replace(/u(?=(((?!>).)*<)|[^<>]*$)/g, 'úú')
    .replace(/c(?=(((?!>).)*<)|[^<>]*$)/g, 'ç')
    .replace(/n(?=(((?!>).)*<)|[^<>]*$)/g, 'ñ')
}

function resolveStrings (path) {
  let deferred = q.defer()
  let request = superagent('GET', path)
  request.set('Content-Type', 'application/json')
  request.accept('application/json')
  request.end(function (error, response) {
    if (error) {
      deferred.reject(error)
    } else {
      deferred.resolve(response)
    }
  })
  return deferred.promise
}

export {
  setLocale,
  i18n
}
